import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Image, Typography } from 'tfc-components';

import bgNotFound from 'assets/images/home/bg-not-found.png';
import Section from 'components/organisms/Section';

const NotFoundBlog: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navigate = useNavigate();
  return (
    <Section className="p-blog_notFound">
      <div className="p-blog_notFound_wrap">
        <Typography.Text fontweight="600" textStyle="center" extendClasses="fs-24x30">
          So sorry,
          {' '}
          <br />
          We couldn’t find what you were looking for...
        </Typography.Text>
        <div className="p-blog_notFound_imageWrap">
          <Image extendClasses="p-blog_notFound_image" imgSrc={bgNotFound} alt="Google" ratio={510 / 367} />
        </div>
        <Button onClick={() => navigate(-1)} variant="primary" extendClasses="o-banner_button o-banner_button-second fButton f-16x24">
          Back to the homepage
        </Button>
      </div>
    </Section>
  );
};

export default NotFoundBlog;
